import {
  JOBPOSTING_FETCHING,
  JOBPOSTING_FAILED,
  JOBPOSTING_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case JOBPOSTING_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case JOBPOSTING_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case JOBPOSTING_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
